import React, { useEffect, useCallback } from 'react';

export function useQuickExit(
  redirectUrl: string,
  setIsDismissed: React.Dispatch<React.SetStateAction<boolean>>,
) {
  const handleRedirect = useCallback(
    (e: React.MouseEvent | React.KeyboardEvent | KeyboardEvent) => {
      e.preventDefault();
      e.stopPropagation();
      try {
        window.location.replace(redirectUrl);
      } catch {
        window.open(redirectUrl, '_self', 'noopener,noreferrer');
      }
    },
    [redirectUrl],
  );

  const handleBlockKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        handleRedirect(e);
      }
    },
    [handleRedirect],
  );

  const handleDismiss = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      setIsDismissed(true);
    },
    [setIsDismissed],
  );

  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.shiftKey && e.key === 'Escape') {
        handleRedirect(e);
      }
    },
    [handleRedirect],
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return {
    handleRedirect,
    handleBlockKeyDown,
    handleDismiss,
  };
}
